import { Log, REMOTE_CONFIG_TOKEN, RemoteConfigProvider } from '@core';
import { from, map, Observable } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';

export class RemoteConfigInitStep extends StartupStep {
  private readonly remoteConfigProvider: RemoteConfigProvider = inject(REMOTE_CONFIG_TOKEN);

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'RemoteConfigInitStep START' });

    return from(this.remoteConfigProvider.fetchAndActivate()).pipe(
      map(() => {
        this.logger.log(Log.Startup, { message: 'RemoteConfigInitStep COMPLETED' });
        return state;
      })
    );
  }
}
